module.exports = __webpack_public_path__ + "img/fraude_six.0004b96a.png";